export default {
  base: {
    bg: 'grey-0',
    borderColor: 'grey-30',
    borderRadius: '4px',
    close: {
      disabled: {
        color: 'grey-60'
      }
    },
    hover: {
      bg: 'primary',
      color: 'grey-0',
      borderColor: 'primary',
      boxShadow: 'none'
    },
    active: {
      bg: 'grey-0',
      borderColor: 'primary',
      boxShadow: 'none'
    },
    disabled: {
      bg: 'grey-05',
      color: 'grey-60',
      borderColor: 'grey-05'
    },
    focus: {
      bg: 'primary',
      color: 'grey-0',
      borderColor: 'primary',
      boxShadow: function boxShadow(t) {
        return "0 0 0 2px ".concat(t.colors.orange);
      }
    }
  },
  variants: {
    disabled: {
      bg: 'grey-05',
      color: 'grey-60',
      borderColor: 'grey-05'
    }
  }
};